import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @memberOf Qualifiers.Source
 * @description An abstract class extended by all Source objects
 */
var BaseSource = /*#__PURE__*/function () {
  function BaseSource() {
    _classCallCheck(this, BaseSource);
  }

  _createClass(BaseSource, [{
    key: "encodeAssetPublicID",
    value:
    /**
     * @description Utility function to encode an asset publicID in an overlay
     * @protected
     * @example
     * encodeAssetPublicID('foo/bar'); // -> foo:bar
     */
    function encodeAssetPublicID(publicID) {
      return publicID.replace(/\//g, ':');
    }
    /**
     * @description
     * Apply a transformation on the image source of the layer
     * @param {SDK.ImageTransformation} t An image transformation to apply to the layer
     * @returns {this}
     */

  }, {
    key: "transformation",
    value: function transformation(t) {
      this._transformation = t;
      return this;
    }
    /**
     * @description Returns the Transformation of the source
     * @return {SDK.Transformation}
     */

  }, {
    key: "getTransformation",
    value: function getTransformation() {
      return this._transformation;
    }
  }]);

  return BaseSource;
}();

export { BaseSource };